import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
let pending = null;

export function usePublicConfig() {
  const [config, setConfig] = useState(cached);

  useEffect(() => {
    if (cached) return;
    if (!pending) {
      pending = api.get("/public-config").then((r) => {
        cached = r.data;
        return cached;
      }).catch(() => null);
    }
    pending.then((c) => c && setConfig(c));
  }, []);

  return config;
}

export function clearPublicConfigCache() {
  cached = null;
  pending = null;
}
